<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteVolunteer" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="volunteersHandler"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat v-if="!trash">
          <v-toolbar-title>Volunteers</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <export-list :volunteers="volunteers" />
          <v-spacer></v-spacer>
          <v-btn
            to="/volunteer"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
            >view all</v-btn
          >
          <v-btn
            @click="showFilterModal = true"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
            <v-icon left dark>mdi-filter-variant</v-icon>Filter
          </v-btn>

          <v-btn
            to="/volunteer/create"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
            <v-icon left dark>mdi-plus-circle-outline</v-icon>New
          </v-btn>
          <v-btn
            to="/volunteer/trash"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark>mdi-delete-outline</v-icon>Trash</v-btn
          >
        </v-toolbar>
        <v-toolbar flat v-else>
          <v-toolbar-title>Volunteers Trash</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item?item.name:'' }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.gender_name }}</td>
          <td>{{ item.address }}</td>
          <td>
            {{ item.phone }}
            <span v-if="item.phone1">| {{ item.phone1 }}</span>
          </td>
          <td>{{ item.code }}</td>
          <td>{{ item.plain_password }}</td>
          <td>{{ item.both_mdr_picts == 1 ? "No" : "Yes" }}</td>
          <td>{{ item.remark }}</td>
          <td v-if="!trash">
            <div class="mr-2">
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class=" white--text"
                depressed
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red darken-1"
                class="white--text"
                depressed
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </td>
          <td v-else>
            <div class="mr-2">
              <v-btn
                @click="recoverData(item)"
                icon
                color="green darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>mdi-refresh</v-icon></v-btn
              >
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>

    <filter-box
      v-bind:dialog="showFilterModal"
      @cancel="showFilterModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";
import FilterBox from "./FilterBox.vue";
import exportList from "./exportList.vue";

export default {
  props: {
    volunteers: {
      type: Array,
    },
    trash: {
      type: Boolean,
    },
  },
  components: {
    exportList,
    ConfirmBox,
    FilterBox,
  },
  data: () => ({
    showFilterModal: false,
    genderFilter: "",
    filterName: "",
    filterPhone: "",
    gender: [
      { id: 1, name: "male" },
      { id: 2, name: "female" },
    ],
    education_status: [
      { id: 1, name: "higher" },
      { id: 2, name: "primary" },
      { id: 3, name: "secondary" },
    ],
    occupation: [
      { id: 1, name: "AM" },
      { id: 2, name: "CHW" },
      { id: 3, name: "Other" },
    ],
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Age", value: "age" },
      { text: "Gender", value: "gender_name" },
      { text: "Address", value: "address" },
      { text: "Phone", value: "phone" },
      { text: "Code", value: "code" },
      { text: "Password", value: "password" },
      { text: "MDR & PICTS", value: "both_mdr_picts" },
      { text: "Remark", value: "remark" },
      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    volunteersHandler() {
      const volunteers = this.volunteers.map((volunteer) => {
        const gender = this.gender.find((item) => {
          return volunteer.gender == item.id;
        });
        volunteer.gender_name = gender?gender.name:'';

        const education_status = this.education_status.find((item) => {
          return volunteer.education_status == item.id;
        });
        volunteer.education_status_name = education_status?education_status.name:'';

       

        const occupation = this.occupation.find((item) => {
          return volunteer.occupation == item.id;
        });
        volunteer.occupation_name = occupation ? occupation.name : '';

        return volunteer;
      });
      return volunteers;
    },
  },
  methods: {
    openConfrimBox(item) {
      console.log(item);
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteVolunteer() {
      let data = {
        id: this.item.id,
      };
      this.$store.dispatch("Volunteer/deleteVolunteer", data).then((isPass) => {
        if (isPass) this.dialog = !this.dialog;
      });
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "volunteer-edit",
        params: {
          id: convertNumber,
        },
      });
    },
    recoverData(item) {
      this.$store.dispatch("Volunteer/recoverVolunteer", {
        id: item.id,
      });
    },
  },
};
</script>

<style scoped></style>
